import {connect} from "react-redux";
import {Link, Button} from '@mui/material';
import React from "react";
import i18n from "../../../i18nSetup";
import {Popper} from "@mui/material";
import SchedulesViewer from "./schedules-viewer";

function SchedulesButton(props) {
  const {fontSize} = props;

  const [anchorEl, setAnchorEl] = React.useState(null);

  const openSchedules = (event) => {
    setAnchorEl(document.getElementById('panelTabs'));
  };

  const closeSchedules = (event) => {
    setAnchorEl( null);
  };

  const clickModal = (e) => {
    e.stopPropagation();
  };

  const open = Boolean(anchorEl);
  const id = open ? 'popperSchedules' : undefined;

  return (
    <div>
      <div>
        <Popper onMouseDown={clickModal} id={id} open={open} anchorEl={anchorEl}
                placement={'left'} sx={{ zIndex: 100, width: Math.min(400, document.documentElement.clientWidth), height: '100%'}}>
          <SchedulesViewer closeView={closeSchedules} {...props} />
        </Popper>
      </div>
        <Button sx={{fontSize: fontSize, color: '#3a9bff', outLine :'none'}}
                variant="text"
                onClick={openSchedules}
        >
          {i18n.t('schedules')}
        </Button>
    </div>
  );
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SchedulesButton)